import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";

const FB_URL = "https://www.facebook.com/cka22";

const paragraphs = [
  "I'm Cameron Boyle, a contemporary Australian artist whose work is deeply influenced by my Aboriginal heritage as a Barkindji and Gunai Kurnai man. My art is inspired by the connection between people, Country, nature, and storytelling — bringing together traditional values with a modern, expressive visual style.",
  "Growing up with an appreciation for the landscapes, wildlife, and cultures that make Australia unique has shaped the way I see the world. Every artwork begins with an idea, a memory, or a simple moment in nature that grows into something layered with colour, movement, and meaning. While some pieces tell clear stories, others are intentionally open, inviting each viewer to discover their own connection and interpretation.",
  "My style combines bold colours, intricate line work, and organic forms to create artworks that feel energetic, uplifting, and full of life. Whether I'm painting native wildlife, coastal scenes, dreamlike landscapes, or symbolic designs, my goal is always the same: to create artwork that sparks conversation, evokes emotion, and brings warmth and character into the spaces where it lives.",
  "My Barkindji and Gunai Kurnai heritage is an important part of who I am and influences the respect I have for Country, culture, and the stories that connect generations. Rather than reproducing traditional cultural artworks, I create contemporary pieces that reflect my own artistic journey while honouring the values of connection, resilience, and respect that have shaped my life.",
  "Every artwork is professionally reproduced using premium materials so collectors can enjoy museum-quality prints, canvases, and products that remain true to the original. Whether you're welcoming one of my artworks into your home, workplace, or gifting it to someone special, I hope it brings a sense of curiosity, positivity, and connection.",
  "Thank you for supporting independent Australian art. Every purchase helps me continue creating, sharing stories through colour, and building a collection that celebrates both contemporary creativity and the enduring connection between people, culture, and Country.",
];

export default function About() {
  return (
    <div data-testid="page-about" className="max-w-[1200px] mx-auto px-5 md:px-10 py-16">
      <p className="overline mb-3">About the artist</p>
      <h1 className="font-display text-5xl md:text-7xl leading-none mb-4">
        Cameron Boyle
      </h1>
      <p data-testid="about-heritage" className="text-[#FF4500] font-display tracking-widest text-lg mb-10">
        Barkindji · Gunai Kurnai · Contemporary Australian artist
      </p>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5 relative">
          <img
            src="https://customer-assets.emergentagent.com/job_indigenous-merch/artifacts/pdl5f5xk_meeee.png"
            alt="Cameron Boyle — artist portrait"
            className="w-full aspect-[4/5] object-cover object-center"
          />
          <img
            src="https://customer-assets.emergentagent.com/job_indigenous-merch/artifacts/pftx9pi2_downloadfile-6.png"
            alt="CKA emblem"
            className="absolute -bottom-6 -right-6 w-24 h-24 md:w-28 md:h-28 object-contain drop-shadow-2xl"
            style={{
              WebkitMaskImage:
                "radial-gradient(circle at center, black 38%, rgba(0,0,0,0.55) 62%, transparent 84%)",
              maskImage:
                "radial-gradient(circle at center, black 38%, rgba(0,0,0,0.55) 62%, transparent 84%)",
            }}
          />
          <p className="mt-3 text-xs text-white/50 uppercase tracking-widest">Cameron Boyle · Studio</p>
          <div className="mt-6 grid grid-cols-2 gap-6 border-t border-white/10 pt-6">
            <div>
              <p className="overline mb-2">Heritage</p>
              <p className="font-display text-xl tracking-wider">Barkindji · Gunai Kurnai</p>
            </div>
            <div>
              <p className="overline mb-2">Based in</p>
              <p className="font-display text-xl tracking-wider">Australia</p>
            </div>
            <div>
              <p className="overline mb-2">Style</p>
              <p className="font-display text-xl tracking-wider">Contemporary · Story-led</p>
            </div>
            <div>
              <p className="overline mb-2">Mediums</p>
              <p className="font-display text-xl tracking-wider">Canvas · Print · Apparel</p>
            </div>
          </div>
        </div>
        <div className="md:col-span-7 space-y-6 text-white/75 leading-relaxed text-lg">
          {paragraphs.map((p, i) => (
            <p key={i} data-testid={`about-para-${i}`}>{p}</p>
          ))}
          <div className="pt-8 flex gap-4 flex-wrap">
            <Link to="/custom" data-testid="about-cta-custom" className="btn-primary">Commission a piece</Link>
            <Link to="/shop" data-testid="about-cta-shop" className="btn-ghost">Shop the collection</Link>
            <a
              href={FB_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="about-facebook"
              className="btn-ghost inline-flex items-center gap-2"
            >
              <Facebook className="w-4 h-4" /> Follow on Facebook
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
